<kendo-splitter orientation="vertical" class="h-100">
  <kendo-splitter-pane size="60%">
    <app-free-services-parcel-request-grid> </app-free-services-parcel-request-grid>
  </kendo-splitter-pane>
  <kendo-splitter-pane>
    <kendo-tabstrip class="h-100" [keepTabContent]="true">
      <kendo-tabstrip-tab
        title="{{ 'FREE_PORTAL_SERVICES.OWNERS' | translate }}"
        [selected]="true"
      >
        <ng-template kendoTabContent>
          <app-fsp-owners-grid></app-fsp-owners-grid>
        </ng-template>
      </kendo-tabstrip-tab>
      )
    </kendo-tabstrip>
  </kendo-splitter-pane>
</kendo-splitter>
